import React from 'react';
import DynamicPage from '../components/DynamicPage';

const ContactPage: React.FC = () => {
  return (
    <DynamicPage 
      pageType="ContactForm"
      title=""
      backButtonText="Back to Home"
    />
  );
};

export default ContactPage;
